import Link from "../../common/Link"
import { TableColumn } from "../../common/Table"
import { IScorer } from "../../helpers/interfaces/ranking"

export const rankScorersColumns: TableColumn<IScorer>[] = [
    {
        id: "player",
        name: "Giocatore",
        data: null,
        render: (_data: null, _index: number, row) => {
            return <>
                {row.nome + " " + row.cognome}
            </>
        }
    },
    {
        id: "team",
        name: "Squadra",
        data: "nomeSquadra",
        render: (data: string, _index: number, row) => {
            return <Link
                href={`/societa/${row.idSquadra}`}
                title={data}
                className="col-12 text-truncate"
            >
                {data}
            </Link>
        }
    },
    {
        id: "goal",
        name: "Goal",
        data: "goalSegnati"
    },
]

export const rankScorersColumnsMobile: TableColumn<IScorer>[] = [
    {
        id: "player-team",
        name: "Giocatore/squadra",
        data: null,
        render: (_data: null, _index: number, row) => {
            return <div className="d-flex flex-column">
                {row.nome + " " + row.cognome}
                <Link
                    href={`/societa/${row.idSquadra}`}
                    title={row.nomeSquadra}
                    className="col-12 text-truncate"
                >
                    <span className="display-6" style={{ fontSize: "0.8em" }}>{row.nomeSquadra}</span>
                </Link>
            </div>
        }
    },
    {
        id: "goal",
        name: "Goal",
        data: "goalSegnati"
    },
]